import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8d0ced18")

_pushScopeId("data-v-8d0ced18")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex inline-block" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_5 = { class: "flex flex-center margin-top-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "inline-block margin-right-10" }
const _hoisted_11 = { class: "flex-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_card_set_preview = _resolveComponent("card-set-preview")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.parts,
      style: {"width":"100%","margin-bottom":"20px"},
      border: ""
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "cardCount",
          width: "160",
          label: "张数"
        }, {
          default: _withId(({row}) => [
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock(_component_el_badge, {
                  key: 0,
                  class: "margin-top-10",
                  type: "danger",
                  "is-dot": _ctx.isTotalCountError(row)
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input_number, {
                      size: "mini",
                      modelValue: row.cardCount,
                      "onUpdate:modelValue": ($event: any) => (row.cardCount = $event),
                      min: 1,
                      max: _ctx.cardCount
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])
                  ]),
                  _: 2
                }, 1032, ["is-dot"]))
              : _createCommentVNode("", true),
            (!_ctx.isEditing)
              ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(row.cardCount), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "textVisible",
          width: "120",
          label: "是否显示文字"
        }, {
          default: _withId(({row}) => [
            _createVNode(_component_el_checkbox, {
              disabled: !_ctx.isEditing,
              modelValue: row.textVisible,
              "onUpdate:modelValue": ($event: any) => (row.textVisible = $event)
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "tagIds",
          label: "标签"
        }, {
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.tagIds, (tagId) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: tagId,
                  closable: "",
                  onClose: ($event: any) => (_ctx.removeTag(row, tagId))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTag(tagId).name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose"]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "240",
          label: "操作"
        }, {
          header: _withId(() => [
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    size: "mini",
                    onClick: _ctx.addPart
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_5, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "mini",
                    onClick: ($event: any) => (_ctx.edit(row))
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "mini",
                    onClick: ($event: any) => (_ctx.duplicate(row))
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "danger",
                    circle: "",
                    icon: "el-icon-minus",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.deleteRow(row))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_badge, {
                type: "danger",
                class: "margin-left-10",
                "is-dot": _ctx.hasError(row.tagIds)
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.preview(row))
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["is-dot"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      title: "选择标签",
      modelValue: _ctx.tagsVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tagsVisible = $event)),
      width: "60%"
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonCardTagCategories, (category) => {
            return (_openBlock(), _createBlock("div", {
              key: category.tagCategoryId
            }, [
              (category.tags)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, _toDisplayString(category.tags[0].category.name) + ": ", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.tags, (tag) => {
                      return (_openBlock(), _createBlock(_component_el_tag, {
                        key: tag.id,
                        onClick: ($event: any) => (_ctx.clickTag(tag)),
                        type: _ctx.isSelectedTag(tag.id) ? 'primary' : 'info'
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(tag.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "type"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.tagConfirmed
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tagsVisible = false))
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      title: "预览",
      direction: "ltr",
      modelValue: _ctx.previewDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.previewDialogVisible = $event)),
      size: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_preview, {
          "card-set-id": _ctx.cardSetId,
          "card-set-parts": _ctx.previewData
        }, null, 8, ["card-set-id", "card-set-parts"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})